import apiClient from '@lib/apiClient';
import { AssociateWorkItemRequest, AssociateWorkItemResponse, CreateFeedbackRequest, CreateFeedbackResponse, DisassociateWorkItemResponse, GetSystemWorkItemsResponse } from '@features/systems/domain/incidentIntegration.types';

const API_BASE_URL = '/systems';

export const incidentIntegrationService = {
  associateWorkItem: async (systemId: string, request: AssociateWorkItemRequest, signal?: AbortSignal): Promise<AssociateWorkItemResponse> => {
    const response = await apiClient.post<AssociateWorkItemResponse>(
      `${API_BASE_URL}/${systemId}/work-items`,
      request,
      {signal}
    );
    return response.data;
  },

  disassociateWorkItem: async (systemId: string, workItemId: number, signal?: AbortSignal): Promise<DisassociateWorkItemResponse> => {
    const response = await apiClient.delete<DisassociateWorkItemResponse>(
      `${API_BASE_URL}/${systemId}/work-items/${workItemId}`,
      {signal}
    );
    return response.data;
  },

  getSystemWorkItems: async (systemId: string, signal?: AbortSignal): Promise<GetSystemWorkItemsResponse> => {
    const response = await apiClient.get<GetSystemWorkItemsResponse>(
      `${API_BASE_URL}/${systemId}/work-items`,
      {signal}
    );
    return response.data;
  },

  createFeedback: async (request: CreateFeedbackRequest, signal?: AbortSignal): Promise<CreateFeedbackResponse> => {
    const response = await apiClient.post<CreateFeedbackResponse>(
      `/cadwell/feedback/work-items`,
      request,
      {signal}
    );
    return response.data;
  },
};